// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"skillprogress-module--statsContainer--vfhhg","statCard":"skillprogress-module--statCard--2lypZ","statCardFull":"skillprogress-module--statCardFull--JFep2"};